<template>
  <div v-bind="$attrs" class="group py-1" tabindex="-1" @focusout="open = false">
    <Label :label="label" :required="required" />
    <div
      class="flex items-center rounded-lg border border-cockpit-line bg-cockpit-canvas text-cockpit-text text-sm relative w-full"
      :class="[{ 'bg-cockpit-canvas': !disabled, 'bg-cockpit-elevated opacity-60': disabled, 'border-cockpit-critical': error }]">
      <div class="w-12 text-center border-r p-3" :class="[!disabled ? 'cursor-pointer' : '']" @click="openDate()">
        <i class="fas fa-calendar"></i>
      </div>
      <input
        v-model="inputDate"
        :disabled="true"
        type="text"
        @input="updateValue"
        :placeholder="placeholder ? placeholder : 'mm/yyyy'"
        class="grow focus:outline-none focus:ring-0 border-none w-full p-2"
        :class="[{ 'bg-cockpit-canvas': !disabled, 'bg-cockpit-elevated': disabled, 'border-cockpit-critical': error }]" />

      <div class="w-12 text-center border-l cursor-pointer p-2" v-if="inputValue && !disabled" @click="clear()">
        <i class="fas fa-times"></i>
      </div>

      <TransitionX>
        <div
          class="absolute z-30 left-0 top-full w-full max-w-[640px] bg-white border rounded p-4 z-50 mt-2 sm:max-w-[500px] sm:p-3 sm:text-sm xs:max-w-[380px] xs:p-2 xs:text-xs"
          v-if="open && !disabled">
          <div class="flex items-center justify-between">
            <p class="border-b-2 border-blue-600 mb-2 sm:text-sm xs:text-xs" v-if="modelValue">
              {{ months[currentMonth - 1] }} de
              {{ currentYear }}
            </p>

            <div class="flex">
              <div
                class="w-8 text-center cursor-pointer text-lg sm:w-6 sm:text-base xs:w-5 xs:text-sm"
                @click="changeYear('-')">
                <i class="fas fa-chevron-circle-left text-blue-600 hover:text-blue-700"></i>
              </div>
              <div
                class="w-8 text-center text-lg cursor-pointer text-blue-600 hover:text-blue-700 sm:w-6 sm:text-base xs:w-5 xs:text-sm"
                @click="changeYear('+')">
                <i class="fas fa-chevron-circle-right"></i>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-4 gap-2 cursor-pointer">
            <div
              v-for="(month, index) in months"
              :key="index"
              :class="`border-4 text-center rounded-lg p-2 m:w-[60px] sm:p-1 xs:w-[50px] xs:p-0.5 ${
                currentMonth == index + 1 ? 'border-blue-600' : ''
              }`"
              @click="changeMonth(index)">
              {{ month }}
            </div>
          </div>
        </div>
      </TransitionX>
    </div>
    <div v-if="error">
      <b class="text-red-400 text-xs p-2">
        {{ error }}
      </b>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  label: String,
  disabled: {
    type: Boolean,
    default: false,
  },
  range: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  error: String,
  placeholder: String,
  modelValue: String,
  monthly: {
    type: Boolean,
    default: false,
  },
})

const isInternalChange = ref(false)
const inputValue = ref('')
const open = ref(false)
const inputDate = ref(null)
const currentYear = ref(null)
const currentMonth = ref(null)
const months = ref(['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'])

const openDate = () => {
  open.value = !open.value
}
const changeMonth = (index) => {
  const formattedMonth = (index + 1).toString().padStart(2, '0')
  inputValue.value = `${currentYear.value}-${formattedMonth}`
  open.value = false
  emit('update:modelValue', inputValue.value)
}

const changeYear = (operation) => {
  if (operation === '-') {
    currentYear.value -= 1
  } else {
    currentYear.value += 1
  }

  inputValue.value = `${currentYear.value}-${currentMonth.value}`
  emit('update:modelValue', inputValue.value)
}

const clear = () => {
  inputDate.value = null
  inputValue.value = null
  emit('update:modelValue', null)
}

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue) {
      const month = Number(newValue.split('-')[1])
      const year = Number(newValue.split('-')[0])
      currentYear.value = year
      currentMonth.value = month
      inputDate.value = `${months.value[month - 1]}/${year}`

      inputValue.value = `${currentYear.value}-${currentMonth.value}`
    } else {
      currentYear.value = new Date().getFullYear()
    }
  },
  { immediate: true }
)
</script>
